import Accordion from "@/pages/home/components/Accordion";
import { faqItems } from "@/mocks/home";

export default function FaqSection() {
  return (
    <section id="faq" className="w-full px-4 md:px-8 py-16 md:py-24 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center max-w-2xl mx-auto">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs md:text-sm">
            <i className="ri-question-line" />
            常见问题
          </span>
          <h2 className="mt-4 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
            你可能想知道的几件事
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            关于地址更新、访问方式与安全性的常见疑问，都整理在下面。点击问题即可展开查看回答。
          </p>
        </div>

        <div className="mt-9">
          <Accordion items={faqItems} defaultOpenId="faq-1" />
        </div>
      </div>
    </section>
  );
}